import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { IOSOperation } from 'src/app/class/mkg-os';
import { Operation } from 'src/app/interface/operation';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'operationTitle'
})
export class OperationTitlePipe implements PipeTransform {
  transform(operation: Operation | IOSOperation): string {
    if(!operation){
      return "";
    }
    let operationDescription = `Operação de: ${operation.entry ? 'ENTRADA' : 'SAÍDA'}\n`;
    operationDescription += operation.generateFinancial ? `Gera financeiro\n` : `Não gera financeiro\n`;
    operationDescription += operation.changeStock ? `Movimenta estoque\n` : `Não movimenta estoque\n`;
    operationDescription += `Documento ${operation.docFiscal ? 'FISCAL' : 'GERENCIAL'} de peças\n`;
    operationDescription += `Documento ${operation.docFiscalServico ? 'FISCAL' : 'GERENCIAL'} de serviços\n`;
    if(operation.operationFunction){
      operationDescription += `Função: ${operation.operationFunction || ""}\n`;
    }
    return operationDescription;
  }
}
